import React from "react";
import { BrandResetPasswordDialog } from "../modals/wizard/BrandDialogs";

function ResetPasswordModal({
  handleResetPassword,
  newPassword,
  setNewPassword,
  confirmPassword,
  setConfirmPassword,
  setShowResetPasswordModal,
}) {
  return (
    <BrandResetPasswordDialog
      open
      onClose={() => {
        setShowResetPasswordModal(false);
        setNewPassword("");
        setConfirmPassword("");
      }}
      newPassword={newPassword}
      setNewPassword={setNewPassword}
      confirmPassword={confirmPassword}
      setConfirmPassword={setConfirmPassword}
      onSubmit={handleResetPassword}
      minLength={6}
    />
  );
}

export default ResetPasswordModal;
